module.exports = __webpack_public_path__ + "static/media/the_cauldron_ic_gr.f42094b0.svg";